export class QuestionsList {
  id: number
  requestNumber: string
  name: string
  surveyAndOpinionPollTemplateName: string
  productName: string | null
  productLogo: string | null
  economicOperatorName: string | null
  economicOperatorLogo: string | null
  availabilityStartDate: string
  availabilityEndDate: string
  answeredDate: string | null
  questions: Question[]
  totalQuestionCount: number
}

export class Question {
  id: number
  title: string
  order: number
  surveyAndOpinionPollQuestionTypeId: number
  questionTypeCode: QuestionTypeCodeEnum
  questionType: string
  isRequired: boolean
  isAttachmentsRequired: boolean
  textAnswer: string | null
  selectedOptionId: number | null
  selectedOptionText: string | null
  selectedOptionTexts: string[]
  selectedOptionIds: number[]
  starRating: number | null
  attachmentUrls: AttachmentUrl[]
  options: Option[]
  conditionalQuestions: ConditionalQuestion[]
}

export class ConditionalQuestion {
  id: number
  parentQuestionId: number
  parentQuestionOptionId: number
  parentQuestionOptionText: string
  question: Question  
}

export class Option {
  id: number
  optionId: number
  text: string
  order: number
}

export class AttachmentUrl {
  id: number
  path: string
  name: string
  extention: string
  size: number
}

export enum QuestionTypeCodeEnum {
  Single_Choice = "Single_Choice",
  Multiple_Choice = "Multiple_Choice",
  Star_Rating = "Star_Rating",
  Text_Area = "Text_Area"
}
